export const fadeSlideIn = {
  hide: { opacity: 0.001, transform: "translateY(70px)" },
  show: { opacity: 1, transform: "translateY(0px)" },
  transition: { transition: "opacity 1.5s, transform 1.5s" },
}
